import { Stack, TextField, Toggle } from '@fluentui/react';
import * as React from 'react';
import { IProfileContact } from '../../../Models/Profile/IProfileContact';
import { BillingForm } from './BillingForm';
import { ContactForm } from './ContactForm';

interface IInvoiceContactFormProps {
    isLoading: boolean;
    contactInfo: IProfileContact;
    propertyChanged: (key: string, value: any) => void;
    isValid: (valid: boolean) => void;
    isValidBilling: (valid: boolean) => void;
}


export const InvoiceContactForm: React.FunctionComponent<IInvoiceContactFormProps> = (props) => {


    const firmaChanged = (event?: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, checked ? true : false);
        }
    }

    const setInfoChange = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }


    return (

        <Stack styles={{ root: { width: '100%' } }}>
            <ContactForm isValid={props.isValid} propertyChanged={props.propertyChanged} isLoading={props.isLoading} contactInfo={props.contactInfo} />
            <Toggle id="differentBillingAddress" checked={props.contactInfo.differentBillingAddress} onChange={firmaChanged} inlineLabel label="Chci použít Odlišnou fakturační adresu / Fakturace na firmu" />
            <BillingForm isValid={props.isValidBilling} visible={props.contactInfo.differentBillingAddress} propertyChanged={props.propertyChanged} isLoading={props.isLoading} contactInfo={props.contactInfo} />                
        </Stack>
     )
}
